// extracted by css-extract-rspack-plugin
export default {"cls1":"mentions_milestone_ping-cls1_GNU","cls2":"mentions_milestone_ping-cls2_S75 mentions_milestone_ping-cls1_GNU"};